import CryptoJS from "crypto-js";
import { AES_SECRET } from "./apiList";

const encryptAES = (data) => {
  const encrypted = CryptoJS.AES.encrypt(
    data,
    CryptoJS.enc.Utf8.parse(AES_SECRET),
    {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    }
  );
  return encrypted.toString();
};

export default encryptAES;
